// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"ribbons_desktopOnly__VvL6G","mobileOnly":"ribbons_mobileOnly__otjpA"};